module.exports = __webpack_public_path__ + "static/img/icon.7749dc54.png";